<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import { RouterLink } from "vue-router";

export interface BreadcrumbItem {
  label: string;
  to?: RouteLocationRaw;
}

defineProps<{
  items: Array<BreadcrumbItem>;
}>();
</script>

<template>
  <nav aria-label="Breadcrumb">
    <ul role="list" class="breadcrumbs">
      <li v-for="(item, index) in items" :key="index">
        <RouterLink v-if="item.to" :to="item.to">{{ item.label }}</RouterLink>
        <span v-else>{{ item.label }}</span>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.breadcrumbs {
  font-size: var(--font-size-sm);
  display: flex;
  gap: var(--spacing-sm);

  li {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 60ch;
  }
}

.breadcrumbs li + li::before {
  content: ">";
  margin-inline-end: var(--spacing-sm);
}
</style>
